@use "ui/styles/fontsOld";

.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  width: fit-content;
  border-radius: 999pc;
  white-space: nowrap;
  font-weight: fontsOld.$medium-weight;

  &.color {
    color: var(--primary-color);
  }

  &.backgroundColor {
    background-color: var(--secondary-background-color);
  }

  &.hasAction {
    padding-right: 4px;
    gap: 12px;
  }

  &.large {
    padding: 2px 12px;
    font-size: fontsOld.$large;

    &.hasAction {
      padding-right: 4px;
    }
  }

  &.small {
    padding: 6px 12px;
    font-size: fontsOld.$medium;

    &.hasAction {
      padding-right: 4px;
    }
  }

  &.mini {
    padding: 1px 6px;
    font-size: fontsOld.$smallX1;

    &.hasAction {
      padding-right: 2px;
    }
  }

  &.smallX1 {
    height: unset;
    padding: 3px 8px;
    font-size: 9px;

    &.hasAction {
      padding-right: 2px;
    }
  }
}

.icon {
  margin-top: 3px;

  div {
    margin-right: 6px;
  }
}

.action {
  display: flex;
  align-items: center;
}